(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCookieBanner', (delay) => ({
      show: false,
      init() {
        setTimeout(() => {
          window.Shopify.loadFeatures([
            {
              name: 'consent-tracking-api',
              version: '0.1',
            }
          ],
          (error) => {
            if (error) {    
              throw error;
            }

            const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
            const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

            if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
              requestAnimationFrame(() => {
                this.show = true;
              });
            }

            document.dispatchEvent(new CustomEvent("eurus:customer-privacy:loaded"));            
          });
        }, delay * 1000);
      },
      handleAccept() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
          requestAnimationFrame(() => {
            this.show = false;
          });
        }
      },
      handleDecline() {
        if (window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
          requestAnimationFrame(() => {
            this.show = false;
          });
        }
      }
    }));
  });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
      sectionId: sectionId,
      pageParam: pageParam,
      currentTab: 1,
      loading: true,
      loaded: [],
      select(index) {
        const selectedPage = index - 1;
        this.currentTab = selectedPage;

        if (!this.loaded.includes(selectedPage)) {
          this.loading = true;
          if (Shopify.designMode) {
            const content = document.createElement('div');
            const template = container.querySelector(`#x-fc-${sectionId}-${index}`);
            if (template) {
              content.appendChild(template.content.firstElementChild.cloneNode(true));
              container.appendChild(content.querySelector('.x-fc-content'));
              template.remove();
            }
            
            this.loading = false;
          } else {
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;

            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;

              if (Shopify.designMode && document.getElementById(contentId)) {
                document.getElementById(contentId).remove();
              }

              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }

              this.loading = false;
            })
          }
        }
      }
    }));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecommendations', {
        load(el, url) {
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                el.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map"] && !window.DesignMode) return;
  try {
    
requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xMap", (data) => ({
      load() {
        this.$el.querySelector(
          "iframe"
        ).src = `https://maps.google.com/maps?q=${data}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
      } 
    }));
  });
});

  } catch(e) { console.error(e); }
})();
})();
